<template>
  <ItemDialog ref="dialogRef" imageType="alert">
    <template v-slot:content-area>
      <h2>開錠に失敗しました</h2>
      <p style="text-align: center; line-height: 20px">{{content}}</p>
    </template>
    <template v-slot:button-area>
      <ItemButton
        label="閉じる"
        actionType="btn-primary"
        @clicked="closeDialog()"
      />
    </template>
  </ItemDialog>
</template>

<script>
import { ref } from "vue";

export default {
  name: "DialogUnlockingFailure",
  setup() {
    const dialogRef = ref(null);
    const content = ref("");

    const openDialog = (errorCode) => {
      setContent(errorCode);
      dialogRef.value.open();
    };

    const closeDialog = () => {
      dialogRef.value.close();
    };

    const setContent = (errorCode) => {
      if(errorCode == "dbs336"){
        content.value = "自転車側で「開始」ボタンを押した直後に、アプリ側で「鍵を開ける」ボタンを押して下さい";
      }else{
        content.value = "お手数ですが、もう一度お試しください";
      }
    }

    return {
      content,
      dialogRef,
      openDialog,
      closeDialog,
    };
  },
};
</script>
